import { JRCAppContainer, JRCAppLeftColumn } from 'index';
import * as React from 'react';
import { JRCAppLeftColumnProps, SectionEntry } from 'types';
import { ChildrenContainer, JRCTemplateBaseProps } from './JRCBase.template';

export type JRCTemplateTwoColumnsProps<T extends SectionEntry> = {
    leftColumn: JRCAppLeftColumnProps<T>;
} & JRCTemplateBaseProps;

export const JRCTemplateTwoColumns: React.FC<any> = <T extends SectionEntry>(props: JRCTemplateTwoColumnsProps<T>) => {
    const { icon, color, title, description } = props.leftColumn;
    return (
        <JRCAppContainer>
            <JRCAppLeftColumn icon={icon} color={color} title={title} description={description} />
            <ChildrenContainer title={props.title} isLoading={props.isLoading}>
                {props.children}
            </ChildrenContainer>
        </JRCAppContainer>
    );
};
